export const defaultSampleFormData = {
  valueDate: '',
  statusId: null,
  isLocked: false,
  createdAt: '',
  createdBy: null,
  dataSubject: {
    id: 0,
    code: undefined,
    name: '' as `${string} - ${string}`,
  },
  legalForm: '',
  dataManager: null,
  sampleDataObjects: [],
  modifiedAt: '',
  modifiedBy: null,
  comments: '',
  dataModifiedAt: null,
  dataModifiedBy: null,
};
